const VALIDATIONS = {
    mandatoryFields: 'Make sure your CSV file includes the 2 required column titles (cv, ad_revenue) and try again.',
    inRange: 'Make sure the conversion values in your CSV file are whole numbers between 0 and 63, and try again.',
    adRevenue: 'Make sure the ad_revenue column values are multiples of $0.005 and try again.',
    adRevenueValues: 'Make sure the ad_revenue column values don\'t contain any letters or special characters, '
        + 'and try again.',
    sortedCV: 'Make sure the conversion values are listed in ascending consecutive numbers starting from 0,'
        + ' and try again.',
    sortedAdRevenue: 'Make sure the ad_revenue values are listed in ascending order, and try again.',
    invalidFormat: 'Invalid CSV format'
};

export default VALIDATIONS;
